import { Typography } from "antd";

const Personalities = () => (<Typography.Title level={2}>Coming Soon</Typography.Title>);

export default Personalities;
